// @flow

/**
 * Component for special UK dated search total price disclaimer. Since UK-only
 * with a hard legally-mandated delivery date, not currently in Lingua - just
 * this component!
 *
 * If this messaging gets expanded to other locales, replace this implementation
 * with a proper <FormattedMessage /> component.
 */
/* istanbul ignore next */
const TaxesAndFeesPaidAtProperty = () =>
    'Additional stay taxes may be payable at the property.';

export default TaxesAndFeesPaidAtProperty;
